module.exports = __webpack_public_path__ + "static/media/map-default.c80d57a9.svg";